export default "__VITE_ASSET__8734b876__"